import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LoginService } from './_services';
import { environment } from '../environments/environment';

import { Title } from '@angular/platform-browser';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  constructor(
    private _router: Router,
    private _login: LoginService,
    private titleService: Title
  ) { }

  ngOnInit() {
    if (environment.redirect && window.location.protocol === 'http:') {
      window.location.href = `https://${window.location.host}${window.location.pathname}`;
    }

    this.titleService.setTitle(environment.siteName);
  }
}
